// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProductFreeGifts-module-freeGiftsForProduct-2GkOR{color:#666b69;text-transform:uppercase;font-weight:var(--weight-light);font-size:14px;line-height:23px}.ProductFreeGifts-module-separator-8wodx{margin:0 !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"freeGiftsForProduct": "ProductFreeGifts-module-freeGiftsForProduct-2GkOR",
	"separator": "ProductFreeGifts-module-separator-8wodx"
};
export default ___CSS_LOADER_EXPORT___;
